import en from './translations.en-US.json';

export const UM_UI_TRANSLATIONS_NAMESPACE = '@project44/iam-team-ui-utils';

export const userManagementUITranslations = { en };
